'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
// Exports the constants used for triggering transitions using Angular Router
var SET_LOCATION = exports.SET_LOCATION = '@@ngReduxRoute/SET_LOCATION';
var BACK = exports.BACK = '@@ngReduxRoute/BACK';

// Router Events
var ROUTE_CHANGE_SUCCESS = exports.ROUTE_CHANGE_SUCCESS = '@@ngReduxRoute/ROUTE_CHANGE_SUCCESS';


//////////////////
// WEBPACK FOOTER
// ../node_modules/ng-redux-route/lib/action-types.js
// module id = 207
// module chunks = 0